<!--  -->
<template>
  <div class="icon-part">
    <div class="icon-part-left">
      <el-scrollbar>
        <div
          class="left-title"
          @click="currentCategory = tab"
          :class="tab === currentCategory ? 'active' : ''"
          :key="tab"
          v-for="tab in categoryList"
        >
          {{ tab }}
        </div>
      </el-scrollbar>
    </div>
    <div class="icon-part-center">
      <el-input
        v-model="iconWd"
        @keyup.enter="search"
        class="searchInput"
        prefix-icon="el-icon-search"
        placeholder="输入关键词"
      />
      <div class="icon-box">
        <el-scrollbar>
          <span
            v-for="(item, index) in iconsList[currentCategory]"
            @click="changeIcon(item.name)"
            :key="index"
            :class="['icon-item', activeIcon == item.name ? 'active' : '']"
          >
            <icon-park
              :type="item.name"
              :theme="iconConfig.theme"
              :size="iconConfig.size"
              :strokeLinecap="iconConfig.strokeLinecap"
              :strokeLinejoin="iconConfig.strokeLinejoin"
              :strokeWidth="iconConfig.strokeWidth"
              :fill="iconConfig.color[iconConfig.theme]"
            />
            <choose-icon v-if="activeIcon == item.name"></choose-icon>
          </span>
        </el-scrollbar>
      </div>
    </div>
    <div class="icon-part-right">
      <el-scrollbar>
        <div class="right-todo">
          <span class="right-title">图标大小</span>
          <div class="right-todo-size">
            <el-slider
              v-model="iconConfig.size"
              :min="12"
              :max="48"
            ></el-slider>
            <el-input-number
              v-model="iconConfig.size"
              controls-position="right"
              :min="12"
              :max="48"
            ></el-input-number>
          </div>
        </div>
        <div class="right-todo" style="margin-top: 16px">
          <span class="right-title">线段粗细</span>
          <div class="right-todo-size">
            <el-slider
              v-model="iconConfig.strokeWidth"
              :min="1"
              :max="4"
            ></el-slider>
            <el-input-number
              v-model="iconConfig.strokeWidth"
              controls-position="right"
              :min="1"
              :max="4"
            ></el-input-number>
          </div>
        </div>
        <div class="right-todo" style="margin-top: 16px">
          <span class="right-title">图标风格（颜色）</span>
          <div class="right-todo-color">
            <div class="icon-style">
              <ul class="icon-style-btn">
                <li
                  v-for="(item, index) in styleBtn"
                  @click="iconConfig.theme = item.value"
                  :class="iconConfig.theme == item.value ? 'active' : ''"
                  :key="index"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <ul class="icon-color">
              <!-- 线性 -->
              <li v-if="iconConfig.theme == 'outline'">
                <div class="icon-color-list">
                  <span class="title">描边颜色</span>
                  <div class="icon-color-check">
                    <el-color-picker
                      v-model="iconConfig.color[iconConfig.theme]"
                      @active-change="
                        (val) => { iconConfig.color[iconConfig.theme] = val }
                      "
                    ></el-color-picker>
                    <el-input v-model="iconConfig.color[iconConfig.theme]"></el-input>
                  </div>
                </div>
              </li>
              <!-- 填充 -->
              <li v-else-if="iconConfig.theme == 'filled'">
                <div class="icon-color-list">
                  <span class="title">填充颜色</span>
                  <div class="icon-color-check">
                    <el-color-picker
                      v-model="iconConfig.color[iconConfig.theme]"
                      @active-change="
                        (val) => { iconConfig.color[iconConfig.theme] = val }
                      "
                    ></el-color-picker>
                    <el-input v-model="iconConfig.color[iconConfig.theme]"></el-input>
                  </div>
                </div>
              </li>
              <!-- 双色 -->
              <li v-else-if="iconConfig.theme == 'two-tone'">
                <div
                  v-for="(item, index) in ['描边颜色', '填充颜色']"
                  class="icon-color-list"
                  :key="index"
                >
                  <span class="title">{{ item }}</span>
                  <div class="icon-color-check">
                    <el-color-picker
                      v-model="iconConfig.color[iconConfig.theme][index]"
                      @active-change="
                        (val) => { iconConfig.color[iconConfig.theme][index] = val }
                      "
                    ></el-color-picker>
                    <el-input v-model="iconConfig.color[iconConfig.theme][index]"></el-input>
                  </div>
                </div>
              </li>
              <!-- 多色 -->
              <li v-else>
                <div
                  v-for="(item, index) in [
                    '外部描边颜色',
                    '外部填充颜色',
                    '内部描边颜色',
                    '内部填充颜色',
                  ]"
                  class="icon-color-list"
                  :key="index"
                >
                  <span class="title">{{ item }}</span>
                  <div class="icon-color-check">
                    <el-color-picker
                      v-model="iconConfig.color[iconConfig.theme][index]"
                      @active-change="
                        (val) => { iconConfig.color[iconConfig.theme][index] = val }
                      "
                    ></el-color-picker>
                    <el-input v-model="iconConfig.color[iconConfig.theme][index]"></el-input>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="right-todo">
          <span class="right-title">端点类型</span>
          <ul class="right-todo-type">
            <li
              v-for="(item, index) in ['round', 'flat', 'square']"
              :class="iconConfig.strokeLinecap == item ? 'active' : ''"
              @click="iconConfig.strokeLinecap = item"
              :key="index"
            >
              <icon-park
                :type="'endpoint-' + item"
                theme="multi-color"
                :size="24"
                :strokeWidth="1"
                :fill="['#333', '#2F88FF', '#FFF', '#9013fe']"
              />
            </li>
          </ul>
        </div>
        <div class="right-todo" style="margin-top: 16px">
          <span class="right-title">拐点类型</span>
          <ul class="right-todo-type">
            <li
              v-for="(item, index) in ['round', 'flat', 'square']"
              :class="iconConfig.strokeLinejoin == item ? 'active' : ''"
              @click="iconConfig.strokeLinejoin = item"
              :key="index"
            >
              <icon-park
                :type="'node-' + item"
                theme="multi-color"
                :size="24"
                :strokeWidth="1"
                :fill="['#333', '#2F88FF', '#FFF', '#9013fe']"
              />
            </li>
          </ul>
        </div>
        <div class="reset-config" @click="restConfig">
          <div>清空配置</div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import { IconPark } from '@icon-park/vue-next/es/all'
import icons from '@icon-park/vue-next/icons.json'
import ChooseIcon from './choose.vue'
export default {
  name: 'IconPart',
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    activeValue: {
      type: String
    },
    imgValue: {
      type: String
    }
  },
  data () {
    return {
      slider: 0,
      iconsList: icons,
      categoryList: [],
      // 风格按钮组
      styleBtn: [{
        name: '线性',
        value: 'outline'
      }, {
        name: '填充',
        value: 'filled'
      }, {
        name: '双色',
        value: 'two-tone'
      }, {
        name: '多色',
        value: 'multi-color'
      }],
      // 图标配置
      iconConfig: {
        theme: 'outline',
        size: 24,
        color: {
          outline: '#333',
          filled: '#333',
          'two-tone': ['#333', '#2F88FF'],
          'multi-color': ['#333', '#2F88FF', '#FFF', '#43CCF8']
        },
        strokeWidth: 4,
        strokeLinecap: 'round', // 端点类型
        strokeLinejoin: 'round' // 拐点类型
      },
      currentCategory: '服饰',
      iconWd: '', // 图标搜索词
      activeIcon: '' // 选中的图标
    }
  },
  components: {
    IconPark,
    ChooseIcon
  },
  mounted () {
    const list = {}
    this.iconsList.map((item) => {
      if (list[item.categoryCN] === undefined) {
        list[item.categoryCN] = []
      }
      list[item.categoryCN].push(item)
    })
    this.iconsList = list
    this.categoryList = Object.keys(list)
  },
  methods: {
    // 搜索图标
    search () {
      let resList = []
      const resObj = {}
      icons.forEach(x => {
        // 搜索标题
        if (x.title.search(this.iconWd) !== -1) {
          resList.push(x)
        } else {
          // 搜索标签
          x.tag.forEach(item => {
            if (item.search(this.iconWd) !== -1) {
              resList.push(x)
            }
          })
        }
      })
      const obj = {}
      // 去重
      resList = resList.reduce(function(item, next) {
        obj[next.id] ? '' : obj[next.id] = true && item.push(next);
        return item;
      }, []);
      // 处理数据
      resList.forEach((item) => {
        if (resObj[item.categoryCN] === undefined) {
          resObj[item.categoryCN] = []
        }
        resObj[item.categoryCN].push(item)
      })
      this.iconsList = resObj
      this.categoryList = Object.keys(resObj)
      this.currentCategory = this.categoryList[0]
    },
    // 清空配置
    restConfig () {
      this.iconConfig = {
        theme: 'outline',
        size: 24,
        color: {
          outline: '#333',
          filled: '#333',
          'two-tone': ['#333', '#2F88FF'],
          'multi-color': ['#333', '#2F88FF', '#FFF', '#43CCF8']
        },
        strokeWidth: 4,
        strokeLinecap: 'round', // 端点类型
        strokeLinejoin: 'round' // 拐点类型
      }
    },
    // 选择图标
    changeIcon (name) {
      this.activeIcon = name
      var svgBase64 = new XMLSerializer().serializeToString(document.querySelector(`.i-icon-${name} svg`))
      const ImgBase64 = `data:image/svg+xml;base64,${window.btoa(svgBase64)}`
      this.$emit('update:activeValue', name)
      this.$emit('update:imgValue', ImgBase64)
    }
  },
  watch: {
    config: {
      handler (val) {
        if (val) {
          this.iconConfig = JSON.parse(JSON.stringify(val))
        }
      },
      immediate: true
    },
    activeValue: {
      handler (val) {
        this.activeIcon = val
      },
      immediate: true
    },
    iconConfig: {
      // 配置变化选择的图标也跟着变化
      handler () {
        const _this = this
        setTimeout(() => {
          const el = document.querySelector(`.i-icon-${_this.activeIcon} svg`)
          if(el==undefined) return
          var svgBase64 = new XMLSerializer().serializeToString(el)
          const ImgBase64 = `data:image/svg+xml;base64,${window.btoa(svgBase64)}`
          this.$emit('update:imgValue', ImgBase64)
        },200)
      },
      deep: true
    }
  }
}
</script>
<style lang='scss' scoped>
::v-deep .el-slider__button {
  width: 8px;
  height: 8px;
  position: relative;
  top: -2px;
}
.icon-part {
  display: flex;
  width: 100%;
  height: 100%;
  .el-scrollbar {
    height: 100% !important;
  }
  &-left {
    border-right: solid 1px rgba(245, 246, 247, 1);
    width: 122px;
    height: 100%;
    box-sizing: border-box;
    .left-title {
      height: 32px;
      line-height: 32px;
      padding: 0 16px 0 8px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      box-sizing: border-box;
      font-size: 14px;
      font-weight: 400;
      color: rgba(153, 163, 173, 1);
      cursor: pointer;
    }
    .active {
      background: rgba(245, 246, 247, 1);
      font-size: 14px;
      font-weight: 400;
      color: rgba(5, 126, 255, 1);
      border: none;
    }
  }
  &-center {
    flex: 1;
    box-sizing: border-box;
    position: relative;
    padding-left: 16px;
    .searchInput {
      // position: absolute;
      // top: 0;
      // left: 16px;
      width: 343px;
      ::v-deep .el-input__inner {
        background: rgba(245, 246, 247, 1);
        border: none;
        border-radius: 4px;
        height: 32px;
        line-height: 32px;
      }
      ::v-deep .el-input__prefix {
        top: -4px;
      }
    }
    .icon-box{
      height: 336px;
      margin-top: 16px;
    }
    .icon-item {
      display: inline-block;
      position: relative;
      width: 55px;
      height: 55px;
      margin-right: 8px;
      margin-bottom: 8px;
      border: 2px solid #f5f6f7;
      border-radius: 4px;
      cursor: pointer;
      .i-icon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .active {
      border-color: #9bcbff;
    }
  }
  &-right {
    width: 197px;
    box-sizing: border-box;
    border-left: solid 1px rgba(245, 246, 247, 1);
    .right-todo {
      padding-left: 16px;
      display: flex;
      width: 100%;
      flex-direction: column;
      padding-bottom: 16px;
      box-sizing: border-box;
      border-bottom: solid 1px rgba(245, 246, 247, 1);
      .i-icon {
        position: relative;
        top: 2px;
      }
      .right-title {
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: rgba(0, 0, 0, 1);
        margin-bottom: 8px;
      }
      &-size {
        display: flex;
        width: 100%;
        ::v-deep .el-slider {
          width: 112px;
          .el-slider__runway {
            height: 2px;
            background: rgba(230, 232, 235, 1);
          }
          .el-slider__bar {
            height: 2px;
            background: rgba(5, 126, 255, 1);
          }
        }
        ::v-deep .el-input-number {
          width: 41px;
          margin-left: 8px;
          font-size: 12px;
          .el-input-number__decrease {
            width: 12px;
            line-height: 12px;
            height: 12px;
            bottom: 7px;
          }
          .el-input-number__increase {
            width: 12px;
            line-height: 12px;
            height: 12px;
            top: 7px;
          }
          .el-input__inner {
            padding-right: 16px;
            padding-left: 6px;
            height: 24px;
            line-height: 24px;
          }
        }
      }
      &-color {
        .icon-style {
          &-btn {
            display: flex;
            flex-wrap: wrap;
            li {
              margin-right: 8px;
              width: 77px;
              height: 28px;
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 8px;
              cursor: pointer;
              font-size: 14px;
              font-weight: 400;
              line-height: 22px;
              border: solid 1px rgba(230, 232, 235, 1);
              box-sizing: border-box;
              &:nth-of-type(2n) {
                margin-right: 0;
              }
              &:hover {
                border: 1px solid rgba(5, 126, 255, 1);
                color: rgba(5, 126, 255, 1);
              }
            }
            .active {
              background: rgba(230, 242, 255, 1);
              border: 1px solid rgba(5, 126, 255, 1);
              color: rgba(5, 126, 255, 1);
            }
          }
        }
        .icon-color {
          display: flex;
          flex-wrap: wrap;
          li {
            display: flex;
            flex-wrap: wrap;
            .icon-color-list {
              display: flex;
              flex-wrap: wrap;
              flex-direction: column;
              margin-right: 8px;
              margin-bottom: 8px;
              .title {
                font-size: 12px;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
              }
              .icon-color-check {
                display: flex;
                align-items: center;
                ::v-deep .el-color-picker {
                  margin-right: 8px;
                  width: 16px;
                  height: 16px;
                  cursor: pointer;
                  box-shadow: 0px 0px 3px 0px rgba(153, 153, 153, 0.31);
                  .el-color-picker__trigger {
                    width: 16px;
                    height: 16px;
                    padding: 0;
                    border: none;
                    .el-color-picker__icon {
                      display: none !important;
                    }
                  }
                }
                .check-box {
                  width: 16px;
                  height: 16px;
                  border-radius: 2px;
                  background: rgba(153, 153, 153, 1);
                  margin-right: 4px;
                }
                ::v-deep .el-input {
                  width: 52px;
                  height: 24px;
                  .el-input__inner {
                    height: 24px;
                    line-height: 24px;
                    padding: 0 8px;
                  }
                }
              }
            }
          }
        }
      }
      &-type {
        display: flex;
        flex-wrap: nowrap;
        li {
          width: 49px;
          height: 28px;
          opacity: 1;
          border-radius: 4px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(230, 232, 235, 1);
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          color: solid rgba(1, 25, 51, 1);
          margin-right: 8px;
          cursor: pointer;
          &:hover {
            border: 1px solid rgba(5, 126, 255, 1);
            color: rgba(5, 126, 255, 1);
          }
        }
        .active {
          background: rgba(230, 242, 255, 1);
          border: 1px solid rgba(5, 126, 255, 1);
          color: rgba(5, 126, 255, 1);
        }
      }
    }
    .reset-config {
      padding-left: 16px;
      div {
        width: 162px;
        height: 32px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(230, 232, 235, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:hover {
          border: 1px solid rgba(5, 126, 255, 1);
          color: rgba(5, 126, 255, 1);
        }
      }
    }
  }
}
</style>
